import React from 'react';
import classnames from 'classnames';
import * as mobxReact from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { OperatorsList } from './operators-list';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import { RoomFormDataVM } from '../../_rooms/_room-form/room-form-data.viewmodel';
import './operators-list-container.scss';
import { IUserOperatorDTO } from '../../../../../api/operators.dao';
import { addText, cancelText } from '../../../../../constants/common-labels.constants';

interface IProps {
   vm: RoomFormDataVM;
   selectOperators: (op) => void;
   searchOperators: (op) => Promise<void>;
   operators: IUserOperatorDTO[];
}

const OperatorsSection = mobxReact.observer((props: IProps) => {
    const nonEmptyOperators = !!props.vm.getOperators().length;
    return (
        <section className='operators-section'>
            <div className={classnames('operators-section__header', { 'operators-section__header-empty': nonEmptyOperators })}>
                <label className='operators-section__header-label'>
                    <FormattedMessage
                        id='oe.common.operators'
                        description='Label text'
                        defaultMessage='Operators' />
                </label>
            </div>
            <OperatorsList
                operators={props.vm.getOperators()}
                removeOperator={email => props.vm.removeOperatorByEmail(email)}
                onOperatorRoleChange={props.vm.onOperatorRoleChange}
            />
            <MultiSelectButton
                items={props.operators}
                disabled={props.vm.getOperatorsWithFullNameProperty()}
                value={props.vm.getOperatorsWithFullNameProperty()}
                keyProperty='email'
                nameProperty='fullName'
                text={<FormattedMessage
                    id='oe.operators.add'
                    description='Button text'
                    defaultMessage='{prefix} Add Operators'
                    values={{prefix: '+'}}
                />}
                applyButtonText={addText()}
                resetButtonText={cancelText()}
                onChange={props.selectOperators}
                filterHandler={props.searchOperators}
            />
        </section>
    );
});

export { OperatorsSection };
